import { render, staticRenderFns } from "./evaluation_committee_commandment.vue?vue&type=template&id=446f84ac&scoped=true&"
import script from "./evaluation_committee_commandment.vue?vue&type=script&lang=js&"
export * from "./evaluation_committee_commandment.vue?vue&type=script&lang=js&"
import style0 from "./evaluation_committee_commandment.vue?vue&type=style&index=0&id=446f84ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446f84ac",
  null
  
)

export default component.exports